const getCount = ({ el, arr }) => {
    return arr.reduce((acc, e) => {
        if (e.id === el.id) acc += 1;
        return acc;
    }, 0);
};

export default getCount;
